<template>
  <v-container fluid class="dim-book-input pa-0 rounded" v-bind="$attrs">
    <div class="dim-book-input-header-row">
      <v-btn color="primary" small class="mr-4" @click="check()">
        {{
          publicMode || (workOrder && workOrder.is_estimate)
            ? "Check and Calculate"
            : "Check"
        }}
      </v-btn>
      <v-menu
        top
        right
        :close-on-content-click="false"
        :close-on-click="false"
        v-model="isIssueMenuVisible"
        v-if="checkIssues.length > 0"
      >
        <template #activator="{ on, attrs }">
          <v-btn color="primary" small class="mr-4" v-bind="attrs" v-on="on">
            Issues ({{ checkIssues.length }})
          </v-btn>
        </template>
        <div class="d-flex white">
          <v-spacer></v-spacer>
          <v-btn
            small
            icon
            @click="
              isIssueMenuVisible = false;
              clickedRowId = null;
            "
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-virtual-scroll
          :items="checkIssues"
          height="250"
          width="600"
          item-height="62"
          :bench="5"
          style="background: white"
        >
          <template #default="{ index, item: { row, issue } }">
            <v-list-item @click="onIssueClick(row)">
              <v-list-item-content>
                <v-list-item-title>
                  <span>ISSUE {{ index + 1 }}</span>
                  <span
                    v-if="!publicMode && (!workOrder || !workOrder.is_estimate)"
                  >
                    - ORDER NO.: {{ row.order_no }}</span
                  >
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ issue }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-chevron-right</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </template>
        </v-virtual-scroll>
      </v-menu>
    </div>
    <div class="dim-book-input-btn-row">
      <span
        class="d-flex align-center"
        v-if="publicMode || (workOrder && workOrder.is_estimate)"
        >Total Amount:
        {{
          checkSum && checkIssues.length === 0 ? $parseCurrency(checkSum) : "-"
        }}</span
      >
      <v-spacer></v-spacer>

      <v-autocomplete
        dense
        class="mr-4 dim-book-input-search-text-field"
        outlined
        hide-details
        :placeholder="
          workOrder && !workOrder.is_estismate
            ? 'Search in Dimbook'
            : 'Search in Estimate'
        "
        @update:search-input="onSearchInputChange"
        hide-no-data
        :loading="isSearchResultLoading"
        :items="searchResults"
        :filter="() => true"
        v-model="selectedSearchResult"
        @input="onSearchResultSelected"
        ref="searchTextField"
      >
        <template #item="{ parent, item }">
          <v-list-item-content>
            <v-list-item-title>
              <span
                >LINE:
                {{
                  publicMode || (workOrder && workOrder.is_estimate)
                    ? item.row_index
                    : item.line_no
                }}</span
              >
              -
              <span>ORDER NO.: {{ item.order_no }}</span>
            </v-list-item-title>
            <v-list-item-title v-if="item.item_no || item.descriptions">
              ITEM: {{ item.item_no }}
              <span class="text--disabled">{{ item.descriptions }}</span>
            </v-list-item-title>
          </v-list-item-content>
        </template>
      </v-autocomplete>

      <v-combobox
        dense
        class="mr-4 dim-book-input-search-text-field"
        outlined
        hide-details
        :placeholder="'Next ADJ'"
        hide-no-data
        :items="['A001', 'A002', 'A003', 'A004', 'A005']"
        :filter="() => true"
        v-model="manualNextAdj"
        v-if="workOrder && !workOrder.is_estimate"
        ref="nextADJTextField"
      >
        <template #item="{ parent, item }">
          <v-list-item-content>
            <v-list-item-title>
              <span> {{ item }} </span>
            </v-list-item-title>
          </v-list-item-content>
        </template>
      </v-combobox>

      <v-btn
        color="primary"
        class="ml-4"
        v-if="workOrder && !workOrder.is_estimate"
        @click="generateXml"
      >
        Export XML
      </v-btn>
      <v-btn
        color="primary"
        class="ml-4"
        v-if="publicMode || (workOrder && workOrder.is_estimate)"
        @click="generateExcel"
      >
        Export Excel
      </v-btn>
      <!--      <v-btn color="primary"-->
      <!--             class="ml-4"-->
      <!--             v-if="adjustments && adjustments.length > 1">-->
      <!--        Adjustments-->
      <!--      </v-btn>-->
      <v-btn
        color="primary"
        class="ml-4"
        v-if="!publicMode"
        :disabled="newRows.length === 0"
        @click="saveDraft"
      >
        Save Draft
      </v-btn>
    </div>
    <div class="dim-book-input-table">
      <div
        :class="[
          'dim-book-input-table-wrapper',
          { 'public-mode': publicMode || (workOrder && workOrder.is_estimate) },
        ]"
      >
        <div class="dim-book-input-header-row">
          <div
            class="dim-book-input-header dim-book-adjustment"
            v-if="!(publicMode || (workOrder && workOrder.is_estimate))"
          >
            DIMBOOK NO.
          </div>
          <div
            class="dim-book-input-header dim-book-adjustment"
            v-if="!(publicMode || (workOrder && workOrder.is_estimate))"
          >
            ADJ
          </div>
          <div class="dim-book-input-header dim-book-line-line-no">
            LINE NO.
          </div>
          <div
            class="dim-book-input-header dim-book-line-order-no"
            v-if="!(publicMode || (workOrder && workOrder.is_estimate))"
          >
            ORDER
          </div>
          <div class="dim-book-input-header dim-book-line-item-no">
            ITEM NO.
          </div>
          <div class="dim-book-input-header dim-book-line-item-description">
            DESCRIPTION
          </div>
          <div
            class="dim-book-input-header dim-book-line-nsr-value"
            v-if="publicMode || (workOrder && workOrder.is_estimate)"
          >
            RATE
          </div>
          <div class="dim-book-input-header dim-book-line-item-unit">UNIT</div>
          <div class="dim-book-input-header dim-book-line-percentage">
            {{
              publicMode || (workOrder && workOrder.is_estimate)
                ? "Contract %"
                : "%"
            }}
          </div>
          <div
            class="dim-book-input-header dim-book-line-sub-ind"
            v-if="!(publicMode || (workOrder && workOrder.is_estimate))"
          >
            N
          </div>
          <div class="dim-book-input-header dim-book-line-times">TIMES</div>
          <div class="dim-book-input-header dim-book-line-measurement-header">
            <div class="dim-book-input-header dim-book-line-measurement-header">
              DIMENSION
            </div>
            <div class="dim-book-input-header dim-book-line-measurements">
              1st
            </div>
            <div class="dim-book-input-header dim-book-line-measurements">
              2nd
            </div>
            <div class="dim-book-input-header dim-book-line-measurements">
              3rd
            </div>
          </div>
          <div
            class="dim-book-input-header dim-book-line-group"
            v-if="!(publicMode || (workOrder && workOrder.is_estimate))"
          >
            G
          </div>
          <div
            class="dim-book-input-header dim-book-line-location"
            v-if="!(publicMode || (workOrder && workOrder.is_estimate))"
          >
            LOCATION
          </div>
          <div class="dim-book-input-header dim-book-line-remark">REMARKS</div>
          <div
            class="dim-book-input-header dim-book-line-amount"
            v-if="publicMode || (workOrder && workOrder.is_estimate)"
          >
            AMOUNT
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on"
                  >mdi-information-outline
                </v-icon>
              </template>
              <span>Quantity in 2 d.p. x Rate with Contract %</span>
            </v-tooltip>
          </div>
          <div
            class="dim-book-input-header dim-book-line-created-by"
            v-if="!(publicMode || (workOrder && workOrder.is_estimate))"
          >
            ADJUSTED BY
          </div>
          <div class="dim-book-input-header dim-book-line-actions"></div>
        </div>
        <RecycleScroller
          class="dim-book-row-wrapper"
          key-field="id"
          :min-item-size="65"
          :items="processedRows"
        >
          <template #default="{ item: row }">
            <div
              :class="[
                'dim-book-row',
                { edited: row.idx !== row.group_length - 1 },
                { 'has-issue': rowIdsWithIssues.indexOf(row.id) !== -1 },
                { 'issue-clicked': clickedRowId === row.id },
              ]"
            >
              <div :class="['dim-book-line', { 'nsr-item': row.nsr }]">
                <div
                  :class="[
                    'dim-book-line-col dim-book-adjustment',
                    { 'new-adjustment': !row.adjustment_dimbook_no },
                  ]"
                  v-if="!(publicMode || (workOrder && workOrder.is_estimate))"
                >
                  {{ row.dim_book_no }}
                </div>
                <div
                  :class="[
                    'dim-book-line-col dim-book-adjustment',
                    { 'new-adjustment': !row.adjustment_dimbook_no },
                  ]"
                  v-if="!(publicMode || (workOrder && workOrder.is_estimate))"
                >
                  {{ row.adjustment_dimbook_no || "NEW" }}
                </div>
                <div class="dim-book-line-col dim-book-line-line-no">
                  {{
                    publicMode || (workOrder && workOrder.is_estimate)
                      ? row.row_index
                      : row.line_no
                  }}
                </div>
                <div
                  class="dim-book-line-col dim-book-line-order-no"
                  v-if="!(publicMode || (workOrder && workOrder.is_estimate))"
                >
                  <v-text-field
                    dense
                    outlined
                    readonly
                    :disabled="row.idx !== row.group_length - 1"
                    hide-details="auto"
                    autocomplete="off"
                    :class="{
                      deleted: row.adjustment === DIMBOOK_ADJUSTMENT.DELETE,
                    }"
                    :value="row.order_no"
                    @click="onEditRowOrderNo(row)"
                  ></v-text-field>
                </div>
                <div class="dim-book-line-col dim-book-line-item-no">
                  <v-text-field
                    dense
                    outlined
                    :disabled="row.idx !== row.group_length - 1"
                    hide-details="auto"
                    autocomplete="off"
                    :class="{
                      deleted: row.adjustment === DIMBOOK_ADJUSTMENT.DELETE,
                    }"
                    :readonly="row.adjustment === DIMBOOK_ADJUSTMENT.DELETE"
                    v-model="row.item_no"
                    @click="onRowItemNoClick(row, $event)"
                    @input="onRowItemNoInput(row, $event)"
                    :append-icon="
                      (!row.nsr || (workOrder && workOrder.is_estimate)) &&
                      row.idx === row.group_length - 1
                        ? null
                        : null
                    "
                    @click:append="onRowItemNoAppendClick(row, $event)"
                  >
                  </v-text-field>
                </div>
                <div
                  :class="[
                    'dim-book-line-col',
                    'dim-book-line-item-description',
                    { disabled: row.idx !== row.group_length - 1 },
                  ]"
                >
                  <v-text-field
                    dense
                    outlined
                    :disabled="row.idx !== row.group_length - 1"
                    hide-details="auto"
                    autocomplete="off"
                    :class="{
                      deleted: row.adjustment === DIMBOOK_ADJUSTMENT.DELETE,
                    }"
                    :readonly="
                      !row.nsr || row.adjustment === DIMBOOK_ADJUSTMENT.DELETE
                    "
                    :placeholder="
                      row.nsr
                        ? publicMode || workOrder.is_estimate
                          ? ''
                          : 'Search in NSR'
                        : 'Search in SOR'
                    "
                    :value="row.descriptions"
                    @click="onRowItemNoAppendClick(row, $event)"
                    @input="onRowItemDescriptionInput(row, $event)"
                  >
                    <template #append v-if="row.idx === row.group_length - 1">
                      <v-icon
                        color="primary"
                        v-if="!row.nsr && row.item"
                        @click="showRowItemDetail(row)"
                      >
                        mdi-information-outline
                      </v-icon>
                      <v-icon
                        color="primary"
                        v-if="
                          (!row.nsr && !row.item) ||
                          (row.nsr && workOrder && !workOrder.is_estimate)
                        "
                        @click="onRowItemNoAppendClick(row, $event)"
                      >
                        mdi-magnify
                      </v-icon>
                    </template>
                  </v-text-field>
                </div>
                <div
                  class="dim-book-line-col dim-book-line-nsr-value"
                  v-if="publicMode || (workOrder && workOrder.is_estimate)"
                >
                  <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    autocomplete="off"
                    :readonly="!row.nsr"
                    :value="
                      !row.nsr
                        ? $parseNumber(getRowValue(row))
                        : getRowValue(row)
                    "
                    :type="!row.nsr ? null : 'number'"
                    min="0"
                    step="0.01"
                    @input="onNsrValueInput(row, $event)"
                  ></v-text-field>
                </div>

                <div class="dim-book-input-header dim-book-line-item-unit">
                  <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    autocomplete="off"
                    :disabled="!row.nsr"
                    :value="getRowUnit(row)"
                    @input="onNsrUnitInput(row, $event)"
                  ></v-text-field>
                </div>

                <!--                <div class="dim-book-line-col dim-book-line-contract-percentage"-->
                <!--                     v-if="publicMode">-->
                <!--                  <v-text-field dense-->
                <!--                                outlined-->
                <!--                                hide-details="auto"-->
                <!--                                autocomplete="off"-->
                <!--                                v-model="row.public_contract_percentage"-->
                <!--                                @input="onPublicContractPercentageInput(row, $event)"></v-text-field>-->
                <!--                </div>-->

                <div class="dim-book-line-col dim-book-line-percentage">
                  <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    autocomplete="off"
                    :id="`${row.id}_percentage`"
                    :class="{
                      deleted: row.adjustment === DIMBOOK_ADJUSTMENT.DELETE,
                    }"
                    :value="row.percentage"
                    :readonly="
                      !!row.adjustment_dimbook_no ||
                      row.adjustment === DIMBOOK_ADJUSTMENT.DELETE
                    "
                    :disabled="
                      (!row.nsr && !!workOrder && workOrder.is_estimate) ||
                      row.idx !== row.group_length - 1
                    "
                    @click="onRowEdit(row, {}, 'percentage')"
                    @input="onValueInput(row, { percentage: $event })"
                  ></v-text-field>
                </div>
                <div
                  class="dim-book-line-col dim-book-line-sub-ind"
                  v-if="!(publicMode || (workOrder && workOrder.is_estimate))"
                >
                  <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    autocomplete="off"
                    :id="`${row.id}_subtract`"
                    :class="{
                      deleted: row.adjustment === DIMBOOK_ADJUSTMENT.DELETE,
                    }"
                    :value="row.subtract ? 'N' : null"
                    :readonly="
                      !!row.adjustment_dimbook_no ||
                      row.adjustment === DIMBOOK_ADJUSTMENT.DELETE
                    "
                    :disabled="row.idx !== row.group_length - 1"
                    @click="onRowEdit(row, { subtract: !row.subtract })"
                    @input="onValueInput(row, { subtract: !row.subtract })"
                  ></v-text-field>
                </div>
                <div class="dim-book-line-col dim-book-line-times">
                  <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    autocomplete="off"
                    :id="`${row.id}_times`"
                    :class="{
                      deleted: row.adjustment === DIMBOOK_ADJUSTMENT.DELETE,
                    }"
                    :value="row.times"
                    :readonly="
                      !!row.adjustment_dimbook_no ||
                      row.adjustment === DIMBOOK_ADJUSTMENT.DELETE
                    "
                    :disabled="row.idx !== row.group_length - 1"
                    placeholder="1"
                    :min="
                      publicMode || (workOrder && workOrder.is_estimate)
                        ? null
                        : 1
                    "
                    @click="onRowEdit(row, {}, 'times')"
                    @input="onValueInput(row, { times: $event })"
                  ></v-text-field>
                </div>
                <div class="dim-book-line-col dim-book-line-measurements">
                  <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    autocomplete="off"
                    :id="`${row.id}_first_measurement`"
                    :class="{
                      deleted: row.adjustment === DIMBOOK_ADJUSTMENT.DELETE,
                    }"
                    :value="row.first_measurement"
                    :readonly="
                      !!row.adjustment_dimbook_no ||
                      row.adjustment === DIMBOOK_ADJUSTMENT.DELETE
                    "
                    :disabled="row.idx !== row.group_length - 1"
                    type="number"
                    max="99999.99"
                    step=".01"
                    @click="onRowEdit(row, {}, 'first_measurement')"
                    @input="onValueInput(row, { first_measurement: $event })"
                  ></v-text-field>
                </div>
                <div
                  :class="[
                    'dim-book-line-col',
                    'dim-book-line-measurements',
                    { disabled: row.dimension_count < 2 },
                  ]"
                >
                  <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    autocomplete="off"
                    :id="`${row.id}_second_measurement`"
                    :class="{
                      deleted: row.adjustment === DIMBOOK_ADJUSTMENT.DELETE,
                    }"
                    :value="row.second_measurement"
                    :readonly="
                      !!row.adjustment_dimbook_no ||
                      row.adjustment === DIMBOOK_ADJUSTMENT.DELETE
                    "
                    :disabled="
                      row.idx !== row.group_length - 1 ||
                      row.dimension_count < 2
                    "
                    type="number"
                    min="0"
                    max="99999.99"
                    step=".01"
                    @click="onRowEdit(row, {}, 'second_measurement')"
                    @input="onValueInput(row, { second_measurement: $event })"
                  ></v-text-field>
                </div>
                <div
                  :class="[
                    'dim-book-line-col',
                    'dim-book-line-measurements',
                    { disabled: row.dimension_count < 3 },
                  ]"
                >
                  <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    autocomplete="off"
                    :id="`${row.id}_third_measurement`"
                    :class="{
                      deleted: row.adjustment === DIMBOOK_ADJUSTMENT.DELETE,
                    }"
                    :value="row.third_measurement"
                    :readonly="
                      !!row.adjustment_dimbook_no ||
                      row.adjustment === DIMBOOK_ADJUSTMENT.DELETE
                    "
                    :disabled="
                      row.idx !== row.group_length - 1 ||
                      row.dimension_count < 3
                    "
                    type="number"
                    min="0"
                    max="99999.99"
                    step=".01"
                    @click="onRowEdit(row, {}, 'third_measurement')"
                    @input="onValueInput(row, { third_measurement: $event })"
                  ></v-text-field>
                </div>
                <div
                  class="dim-book-line-col dim-book-line-group"
                  v-if="!(publicMode || (workOrder && workOrder.is_estimate))"
                >
                  <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    autocomplete="off"
                    :id="`${row.id}_group`"
                    :class="{
                      deleted: row.adjustment === DIMBOOK_ADJUSTMENT.DELETE,
                    }"
                    :value="row.group ? 'G' : null"
                    :readonly="
                      !!row.adjustment_dimbook_no ||
                      row.adjustment === DIMBOOK_ADJUSTMENT.DELETE
                    "
                    :disabled="row.idx !== row.group_length - 1"
                    @click="onRowEdit(row, { group: !row.group })"
                    @input="onValueInput(row, { group: !row.group })"
                  ></v-text-field>
                </div>
                <div
                  class="dim-book-line-col dim-book-line-location"
                  v-if="!(publicMode || (workOrder && workOrder.is_estimate))"
                >
                  <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    autocomplete="off"
                    :id="`${row.id}_location`"
                    :class="{
                      deleted: row.adjustment === DIMBOOK_ADJUSTMENT.DELETE,
                    }"
                    :value="row.location"
                    :readonly="
                      !!row.adjustment_dimbook_no ||
                      row.adjustment === DIMBOOK_ADJUSTMENT.DELETE
                    "
                    :disabled="row.idx !== row.group_length - 1"
                    @click="onRowEdit(row, {}, 'location')"
                    @input="onValueInput(row, { location: $event })"
                  ></v-text-field>
                </div>
                <div class="dim-book-line-col dim-book-line-remark">
                  <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    autocomplete="off"
                    :id="`${row.id}_remark`"
                    :class="{
                      deleted: row.adjustment === DIMBOOK_ADJUSTMENT.DELETE,
                    }"
                    :value="row.remark"
                    :readonly="
                      !!row.adjustment_dimbook_no ||
                      row.adjustment === DIMBOOK_ADJUSTMENT.DELETE
                    "
                    :disabled="row.idx !== row.group_length - 1"
                    @click="onRowEdit(row, {}, 'remark')"
                    @input="onValueInput(row, { remark: $event })"
                  ></v-text-field>
                </div>
                <div
                  class="dim-book-line-col dim-book-line-amount"
                  v-if="publicMode || (workOrder && workOrder.is_estimate)"
                >
                  <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    autocomplete="off"
                    :id="`${row.id}_amount`"
                    :value="
                      row.row_amount ? $parseNumber(row.row_amount) : null
                    "
                    readonly
                  >
                  </v-text-field>
                </div>
                <div
                  class="dim-book-line-col dim-book-line-created-by"
                  v-if="!(publicMode || (workOrder && workOrder.is_estimate))"
                >
                  {{ row.adjusted_by || "" }}
                </div>
                <div class="dim-book-line-col dim-book-line-actions">
                  <v-btn
                    text
                    color="primary"
                    v-if="row.idx === row.group_length - 1"
                    :disabled="row.adjustment === DIMBOOK_ADJUSTMENT.DELETE"
                    @click="onRowNsr(row)"
                  >
                    NSR
                  </v-btn>
                  <v-btn
                    icon
                    color="primary"
                    v-if="row.idx === row.group_length - 1"
                    @click="onRowDelete(row)"
                  >
                    <v-icon
                      v-if="
                        publicMode ||
                        (workOrder && workOrder.is_estimate) ||
                        row.adjustment_dimbook_no
                      "
                    >
                      mdi-delete
                    </v-icon>
                    <v-icon v-else>mdi-arrow-u-right-bottom</v-icon>
                  </v-btn>
                </div>
              </div>
              <div
                :class="['dim-book-row-bottom']"
                v-if="row.idx === row.group_length - 1"
                @click="onRowInsert(row)"
              >
                <div class="dim-book-row-bottom-add-btn">
                  <v-icon color="white">mdi-plus</v-icon>
                </div>
              </div>
            </div>
            <!--            </DynamicScrollerItem>-->
          </template>
        </RecycleScroller>
      </div>
    </div>
  </v-container>
</template>

<script>
import { v4 as uuid } from "uuid";
import {
  computed,
  onMounted,
  onUnmounted,
  ref,
  watch,
} from "@vue/composition-api";
import _ from "lodash";
import SearchSorDialog from "@/components/sor/SearchSorDialog";
import { DIMBOOK_ADJUSTMENT, UNIT_ID } from "@/constants";
import { ACTION_TYPES } from "@/store/types";
import SearchNsrDialog from "@/components/nsr/SearchNsrDialog";
import DimBookRowOrderNoInputModal from "@/components/dimbook/DimBookRowOrderNoInputModal";
import SorItemDetailDialog from "@/components/sor/SorItemDetailDialog";
import * as XLSX from "xlsx";

export default {
  name: "DimBookInput",
  props: {
    publicMode: Boolean,
    sorId: String,
    sorName: String,

    workOrderId: String,
    checkTrigger: Boolean,
    changed: Boolean,
  },
  setup(props, { root, emit }) {
    const workOrder = ref(null);
    const contractPercentageMap = computed(() => {
      if (workOrder.value) {
        return JSON.parse(workOrder.value.contract_year.percentages);
      }

      return {};
    });

    const dimbooks = ref([]);
    const dimbookMap = computed(() => {
      let map = {};

      _.forEach(dimbooks.value, (a) => {
        map[a.id] = a;
      });

      return map;
    });

    // Adjustment Dimbooks
    const adjustments = ref([]);
    const nextAdjustmentDimbookNo = computed(() => {
      let lastAdjustmentDimbook = _.last(
        _.sortBy(adjustments.value, "adjustment_dimbook_no"),
      );

      if (lastAdjustmentDimbook) {
        let num = parseInt(
          lastAdjustmentDimbook.adjustment_dimbook_no.substring(1),
        );
        return `A${(num + 1).toString().padStart(3, "0")}`;
      } else {
        return "A000";
      }
    });
    const adjustmentMap = computed(() => {
      let map = {};

      _.forEach(adjustments.value, (a) => {
        map[a.id] = a;
      });

      return map;
    });
    const manualNextAdj = ref(null);

    // Rows
    const rows = ref([]);
    const getNextOrderNo = function (dimBookId, after) {
      let nextRow = _.find(_.orderBy(rows.value, "order_no"), (r) => {
        return (!r.dim_book || r.dim_book === dimBookId) && r.order_no > after;
      });

      let nextOrderNo = null;
      if (nextRow) {
        nextOrderNo = Math.floor((nextRow.order_no + after) / 2);
      } else {
        nextOrderNo = after + 50;
      }

      let existing = _.find(
        rows.value,
        (r) =>
          (!r.dim_book || r.dim_book === dimBookId) &&
          r.order_no === nextOrderNo,
      );
      if (existing) {
        return null;
      } else {
        return nextOrderNo;
      }
    };
    const getNextLineNo = function (given_rows = []) {
      if (given_rows.length > 0) {
        return _.maxBy(given_rows, "line_no").line_no + 1;
      }
      return _.maxBy(rows.value, "line_no").line_no + 1;
    };
    watch(
      () => rows.value.length,
      (newValue) => {
        if (newValue === 0) {
          rows.value.push({
            adjustment: DIMBOOK_ADJUSTMENT.INSERT,
            dim_book_adjustment: null,
            order_no: 100,
            line_no: 1,
            id: uuid(),
          });
        }
      },
      { immediate: true },
    );
    const editedRowIds = computed(() => {
      return _.filter(rows.value, (r) => r.original_id).map(
        (r) => r.original_id,
      );
    });
    const newRows = computed(() => {
      return _.filter(rows.value, (r) => !r.dim_book_adjustment);
    });
    const processedRows = computed(() => {
      // Assign Line No to New Rows
      let withLineNos = [...rows.value];
      let withoutLineNos = _.sortBy(
        _.remove(withLineNos, (r) => !r.line_no),
        "order_no",
      );
      let nextLineNo = getNextLineNo();
      const assignedLineNos = withoutLineNos.map((r) => {
        nextLineNo += 1;
        return {
          ...r,
          line_no: nextLineNo - 1,
        };
      });

      const groupedByLineNo = _.groupBy(
        [...withLineNos, ...assignedLineNos],
        (r) => {
          let dimBook = dimbookMap.value[r.dim_book];
          return `${dimBook ? dimBook.id : ""}_${r.line_no}`;
        },
      );
      const sortedByAdjustment = _.mapValues(groupedByLineNo, (rows) => {
        const newRows = _.filter(rows, (r) => !r.dim_book_adjustment);
        const existingRows = _.sortBy(
          _.filter(rows, (r) => !!r.dim_book_adjustment),
          (r) =>
            adjustmentMap.value[r.dim_book_adjustment].adjustment_dimbook_no,
        );
        return [...existingRows, ...newRows];
      });
      const sortedByLastNewRowOrderNo = _.sortBy(
        _.values(sortedByAdjustment),
        (rows) => {
          let sortedNewRowLast = _.sortBy(rows, (r) =>
            r.dim_book_adjustment ? 0 : 1,
          );
          return _.last(sortedNewRowLast).order_no;
        },
      );
      let flattened = [];
      let currentGroupDimension = null;
      let currentGroup = [];
      sortedByLastNewRowOrderNo.forEach((rows) => {
        rows.forEach((row, idx, arr) => {
          if (
            editedRowIds.value.indexOf(row.id) === -1 &&
            currentGroupDimension === null
          ) {
            currentGroupDimension = getRawRowDimensionCount(row);
          }
          // let dimensionCount = getRawRowDimensionCount(row);

          let percentage = row.percentage;
          if (
            workOrder.value &&
            workOrder.value.is_estimate &&
            row.item &&
            !row.nsr
          ) {
            let p =
              contractPercentageMap.value[
                row.item.item_group.sub_sub_section.sub_section.section.order_no.toString()
              ];
            if (p !== undefined) {
              percentage = p;
            }
          }

          currentGroup.push({
            idx, // idx in row group
            group_length: arr.length,
            id: row.id,
            adjustment: row.adjustment,
            original_id: row.original_id,
            item: row.item,

            dim_book: row.dim_book,
            dim_book_no: row.dim_book
              ? dimbookMap.value[row.dim_book].dimbook_no
              : null,
            adjustment_dimbook_no: row.dim_book_adjustment
              ? adjustmentMap.value[row.dim_book_adjustment]
                  .adjustment_dimbook_no
              : null,
            line_no: row.line_no,
            order_no: row.order_no,
            item_no: getRawRowItemNo(row),
            descriptions: getRawRowItemDescription(row),
            percentage: percentage,
            subtract: row.subtract,
            times: row.times,
            dimension_count:
              editedRowIds.value.indexOf(row.id) !== -1
                ? getRawRowDimensionCount(row)
                : currentGroupDimension,
            first_measurement: row.first_measurement,
            ori_first_measurement: row.first_measurement,
            ori_second_measurement: row.second_measurement,
            ori_third_measurement: row.third_measurement,
            second_measurement:
              editedRowIds.value.indexOf(row.id) !== -1 ||
              currentGroupDimension >= 2
                ? row.second_measurement
                : null,
            third_measurement:
              editedRowIds.value.indexOf(row.id) !== -1 ||
              currentGroupDimension >= 3
                ? row.third_measurement
                : null,
            group: row.group,
            location: row.location,
            remark: row.remark,

            // NSR
            nsr: row.nsr,
            nsr_item_no: row.nsr_item_no,
            nsr_value: row.nsr_value,
            nsr_unit: row.nsr_unit,
            nsr_unit_id: row.nsr_unit_id,

            // Public
            public_contract_percentage: row.public_contract_percentage,

            adjusted_by: row.adjusted_by,

            row_amount: row.row_amount,
            row_index: 1 + flattened.length + currentGroup.length,
          });

          // ER366 get the first non-deleted row
          let firstNonDeletedRow = null;
          let firstNoneDeleteRowIndex = null;
          for (let i = 0; i < currentGroup.length; i++) {
            const current_item = currentGroup[i];
            const next_item =
              i + 1 < currentGroup.length ? currentGroup[i + 1] : null;
            if (current_item.adjustment !== DIMBOOK_ADJUSTMENT.DELETE) {
              if (
                !next_item ||
                (next_item.adjustment !== DIMBOOK_ADJUSTMENT.DELETE &&
                  next_item.adjustment !== DIMBOOK_ADJUSTMENT.UPDATE)
              ) {
                firstNonDeletedRow = current_item;
                firstNoneDeleteRowIndex = i;
                break;
              }
            }
          }

          // ER366 assign dimension count to all rows after the first non-deleted row
          if (firstNonDeletedRow && firstNoneDeleteRowIndex !== null) {
            const firstNonDeletedRowDimensionCount =
              getRawRowDimensionCount(firstNonDeletedRow);

            for (
              let i = firstNoneDeleteRowIndex;
              i < currentGroup.length;
              i++
            ) {
              // if (
              //   currentGroup[0].id === "7149b327-46a3-4441-80d3-db280c8c3374"
              // ) {
              //   console.log(currentGroup[i]);
              //   console.log(firstNonDeletedRowDimensionCount);
              // }
              currentGroup[i].dimension_count =
                firstNonDeletedRowDimensionCount;
              currentGroup[i].first_measurement =
                firstNonDeletedRowDimensionCount >= 1
                  ? currentGroup[i].ori_first_measurement
                  : null;
              currentGroup[i].second_measurement =
                firstNonDeletedRowDimensionCount >= 2
                  ? currentGroup[i].ori_second_measurement
                  : null;
              currentGroup[i].third_measurement =
                firstNonDeletedRowDimensionCount >= 3
                  ? currentGroup[i].ori_third_measurement
                  : null;
            }
          }

          if (idx === arr.length - 1) {
            if (
              row.group ||
              props.publicMode ||
              (workOrder.value && workOrder.value.is_estimate)
            ) {
              flattened = _.concat(flattened, currentGroup);
              currentGroupDimension = null;
              currentGroup = [];
            }
          }
        });
      });

      if (currentGroup.length > 0) {
        flattened = _.concat(flattened, currentGroup);
      }
      return flattened;
    });
    const editRow = function (row, changes, focusInput) {
      let originalRow = _.find(rows.value, { id: row.id });
      // Check if row is original
      if (originalRow.dim_book_adjustment) {
        const newId = uuid();
        rows.value.push({
          ...originalRow,
          ...changes,
          adjustment: DIMBOOK_ADJUSTMENT.UPDATE,
          dim_book_adjustment: null,
          id: newId,
          original_id: row.id,
        });

        if (focusInput) {
          setTimeout(() => {
            document.getElementById(`${newId}_${focusInput}`).focus();
          }, 500);
        }
      } else {
        const idx = _.findIndex(rows.value, { id: originalRow.id });

        rows.value.splice(idx, 1, { ...originalRow, ...changes });
      }
    };

    // Order No
    const onEditRowOrderNo = async function (row) {
      // Check if row is the last in group
      if (
        row.idx !== row.group_length - 1 ||
        row.adjustment === DIMBOOK_ADJUSTMENT.DELETE
      ) {
        return;
      }

      // Determine Range
      let min = 1;
      let max = 9999999;
      let dimBook = dimbookMap.value[row.dim_book];
      let dimBookIdx = _.findIndex(dimbooks.value, { id: dimBook.id });
      if (dimBookIdx !== 0) {
        let previousDimBook = dimbooks.value[dimBookIdx - 1];
        let lastOriginalRow = _.last(
          _.sortBy(
            _.filter(rows.value, { dim_book: previousDimBook.id }),
            "order_no",
          ),
        );
        min = lastOriginalRow.order_no + 100;
      }
      if (dimBookIdx + 1 !== dimbooks.value.length) {
        let nextDimBook = dimbooks.value[dimBookIdx + 1];
        let firstOriginalRow = _.first(
          _.sortBy(
            _.filter(rows.value, { dim_book: nextDimBook.id }),
            "order_no",
          ),
        );
        max = firstOriginalRow.order_no - 1;
      }

      const orderNo = await root.$dialog.showAndWait(
        DimBookRowOrderNoInputModal,
        {
          showClose: false,
          persistent: true,
          initialOrderNo: row.order_no,
          existingOrderNo: rows.value.map((r) => r.order_no),
          min,
          max,
        },
      );

      if (!orderNo) {
        return;
      }

      editRow(row, {
        order_no: parseInt(orderNo),
      });
    };

    // Item No
    const getRawRowItemNo = function (row) {
      if (row.nsr) {
        return row.nsr_item_no;
      } else {
        return row.item
          ? `${row.item.item_group.sub_sub_section.sub_section.section.order_no
              .toString()
              .padStart(2, "0")}${row.item.item_group.item_prefix}${
              row.item.category ? row.item.category.suffix : "A"
            }`
          : "";
      }
    };
    const onRowItemNoClick = async function (row, evt) {
      if (!row.nsr) {
        // Non-NSR: let user enter item no
        return;
      }

      if (props.publicMode) {
        // Public: let user enter item no
        return;
      }

      if (workOrder.value && workOrder.value.is_estimate) {
        // Estimate: let user enter item no
        return;
      }

      // Not public nor estimate: show search modal
      try {
        const changes = await selectNsrItem(evt);
        editRow(row, changes);
      } catch (e) {
        console.log(e);
      }
    };
    const onRowItemNoInput = _.debounce(async function (row, evt) {
      // validate item no
      const itemNo = evt.toUpperCase();
      // console.log(row);
      if (row.nsr) {
        editRow(row, {
          nsr_item_no: itemNo,
        });
      } else if (/^[0-9]{5}[A-Z]{1}$/.test(itemNo)) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/sor/items/",
          params: {
            sor_id: props.publicMode
              ? props.sorId
              : workOrder.value.contract.finalised_sor,
            filters: {
              "item_group.is_deleted": { exact: true, value: false },
              item_no: { exact: true, value: itemNo.toUpperCase() },
            },
          },
        });

        if (response.body.success && response.body.items.length === 1) {
          const changes = {
            item: { ...response.body.items[0] },
          };

          // refresh the row first
          // let originalRow = _.find(rows.value, { id: row.id });
          // const idx = _.findIndex(rows.value, { id: originalRow.id });
          // rows.value.splice(idx, 1, {
          //   ...originalRow,
          //   ...changes,
          // });

          editRow(row, {
            item: { ...response.body.items[0] },
          });
        } else {
          alert(`Cannot find item ${itemNo.toUpperCase()}`);
        }
      } else if (itemNo.length === 0) {
        editRow(row, {
          item: null,
        });
      }
    }, 1000);
    const shouldShowItemNoAppendIcon = function (row) {
      return !row.nsr || (workOrder.value && !workOrder.value.is_estimate);
    };
    const onRowItemNoAppendClick = async function (row, evt) {
      if (row.idx !== row.group_length - 1) return;
      if (row.adjustment === DIMBOOK_ADJUSTMENT.DELETE) return;
      if (props.publicMode && row.nsr) return;
      if (row.nsr && workOrder.value && workOrder.value.is_estimate) return;

      try {
        let changes = {};
        if (!row.nsr) {
          changes = await selectItem(evt);
        } else {
          changes = await selectNsrItem(evt);
        }
        // refresh the row first
        // let originalRow = _.find(rows.value, { id: row.id });
        // const idx = _.findIndex(rows.value, { id: originalRow.id });
        // rows.value.splice(idx, 1, {
        //   ...originalRow,
        //   ...changes,
        // });
        editRow(row, changes);
      } catch (e) {
        if (e) {
          console.log(e);
        }
      }
    };

    // Description
    const getRawRowItemDescription = function (row) {
      if (row.nsr) {
        return row.nsr_action_description;
      } else {
        return row.item ? row.item.action_description : "";
      }
    };
    const onRowItemDescriptionInput = _.debounce(function (row, evt) {
      if (row.adjustment === DIMBOOK_ADJUSTMENT.DELETE) {
        return;
      }

      if (
        !props.publicMode &&
        workOrder.value &&
        !workOrder.value.is_estimate
      ) {
        return;
      }

      editRow(row, {
        nsr_action_description: evt,
      });
    }, 1000);
    const showRowItemDetail = async function (row) {
      if (row.item) {
        const addedItem = await root.$dialog.showAndWait(SorItemDetailDialog, {
          persistent: true,
          width: "90vw",

          workOrder: workOrder.value,

          queryParams: {
            sor_id: props.publicMode
              ? props.sorId
              : workOrder.value.contract.finalised_sor,
            filters: { id: { exact: true, value: row.item.id } },
          },
          sorName: props.sorName,
        });

        if (addedItem) {
          const newRowId = onRowInsert(row);
          const newRow = _.find(rows.value, { id: newRowId });
          editRow(newRow, {
            item: addedItem,
          });
        }
      }
    };

    // Rate
    const getRowValue = function (row) {
      if (row.nsr) {
        return row.nsr_value;
      } else {
        if (row.item) {
          return row.item.value;
        }
      }
      return 0;
    };

    // Unit
    const getRawRowDimensionCount = function (row) {
      if (row.nsr && row.nsr_unit_id) {
        console.log("b");
        return {
          [UNIT_ID.CUBIC]: 3,
          [UNIT_ID.SQUARE]: 2,
          [UNIT_ID.LINEAR]: 1,
          [UNIT_ID.WEIGHT]: 3,
          [UNIT_ID.PER_ITEM]: 1,
        }[row.nsr_unit_id];
      }

      if (!row.nsr && row.item) {
        return {
          [UNIT_ID.CUBIC]: 3,
          [UNIT_ID.SQUARE]: 2,
          [UNIT_ID.LINEAR]: 1,
          [UNIT_ID.WEIGHT]: 3,
          [UNIT_ID.PER_ITEM]: 1,
        }[row.item.item_group.sub_sub_section.unit_id];
      }

      return 99;
    };
    const getRowUnit = function (row) {
      if (row.nsr) {
        return row.nsr_unit;
      } else if (row.item) {
        return root.$processedUnit(row.item.item_group.sub_sub_section.unit);
      }
      return "";
    };
    const getRowUnitId = function (row) {
      if (row.nsr) {
        return row.nsr_unit_id;
      } else if (row.item) {
        return row.item.item_group.sub_sub_section.unit_id;
      }
      return "";
    };

    const getRowAmount = function (row) {
      let percentage = 0;
      if (row.percentage) {
        let parsed = parseFloat(row.percentage);
        if (isNaN(parsed) || parsed <= -100) {
          ("");
        } else if (row.percentage.indexOf(".") !== -1) {
          ("");
        } else {
          percentage = parsed;
        }
      }

      let product = parseFloat(row.first_measurement) || 0;
      if (row.second_measurement) product *= parseFloat(row.second_measurement);
      if (row.third_measurement) product *= parseFloat(row.third_measurement);
      if (row.times) product *= parseFloat(row.times);
      if (row.subtract) product *= -1;
      product *= (100 + percentage) / 100;
      return product.toFixed(2);
    };

    // NSR Unit Price
    const onNsrValueInput = function (row, evt) {
      editRow(row, {
        nsr_value: evt,
      });
    };
    const onNsrUnitInput = function (row, evt) {
      editRow(row, {
        nsr_unit: evt,
      });
    };

    // Public Contract Percentage
    const onPublicContractPercentageInput = function (row, evt) {
      editRow(row, {
        public_contract_percentage: evt,
      });
    };

    // General Fields
    const getValue = function (row, field) {
      if (typeof field.value === "string") {
        if (field.boolean) {
          return row[field.value] ? field.boolean : "";
        }

        return row[field.value];
      } else if (typeof field.value === "function") {
        return field.value(row);
      }
      return "";
    };
    const onRowEdit = async function (row, changes, focusField) {
      // Check if row is the last in group
      if (
        row.idx !== row.group_length - 1 ||
        row.adjustment === DIMBOOK_ADJUSTMENT.DELETE
      ) {
        return;
      }

      try {
        editRow(row, changes, focusField);
      } catch (e) {
        if (e) {
          console.log(e);
        }
      }
    };
    const onValueInput = function (row, changes) {
      editRow(row, changes);
    };
    const onRowInsert = function (row) {
      const newId = uuid();
      let newOrderNo;
      if (props.publicMode) {
        let nextOrderNo = _.find(_.sortBy(rows.value, "order_no"), (r) => {
          return r.order_no > row.order_no;
        });
        if (nextOrderNo) {
          newOrderNo = Math.ceil((row.order_no + nextOrderNo.order_no) / 2);
        } else {
          newOrderNo = row.order_no + 100;
        }
      } else {
        newOrderNo = getNextOrderNo(row.dim_book, row.order_no);

        if (!newOrderNo) {
          alert("Cannot insert more rows here");
          return;
        }
      }

      let newLineNumber = getNextLineNo();

      try {
        let currentDimBook = row.dim_book;
        const current_dim_book_rows = rows.value.filter((row_data) => {
          return row_data.dim_book === currentDimBook;
        });
        newLineNumber = getNextLineNo(current_dim_book_rows);
      } catch (e) {
        console.log(e);
        newLineNumber = getNextLineNo();
      }

      rows.value.push({
        adjustment: DIMBOOK_ADJUSTMENT.INSERT,
        dim_book: row.dim_book,
        order_no: newOrderNo,
        line_no: newLineNumber,
        id: newId,
        location: "DITTO",
      });
      return newId;
    };
    const onRowNsr = function (row) {
      let nsr_attrs = {};
      if (
        !row.nsr &&
        row.item &&
        (props.publicMode || (workOrder.value && workOrder.value.is_estimate))
      ) {
        // Clone Item No and Description to NSR counterpart if is public or estimate
        nsr_attrs = {
          percentage: row.percentage,
          nsr_item_no: getRawRowItemNo(row),
          nsr_action_description: getRawRowItemDescription(row),
          nsr_value: getRowValue(row),
          nsr_unit: getRowUnit(row),
          nsr_unit_id: getRowUnitId(row),
        };
      }

      editRow(row, {
        ...nsr_attrs,
        nsr: !row.nsr,
      });
    };
    const onRowDelete = function (row) {
      if (row.adjustment_dimbook_no) {
        // Delete Original Line
        rows.value.push({
          ...row,
          adjustment: DIMBOOK_ADJUSTMENT.DELETE,
          adjustment_dimbook_no: null,
          id: uuid(),
          original_id: row.id,
        });
      } else {
        const idx = _.findIndex(rows.value, { id: row.id });
        rows.value.splice(idx, 1);
      }
    };

    const load = async function () {
      if (props.workOrderId) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/contract/work_order/dimbooks/",
          params: {
            work_order_id: props.workOrderId,
          },
        });

        if (response.body.success) {
          workOrder.value = response.body.work_order;
          dimbooks.value = _.sortBy(response.body.dimbooks, "dim_book_no");
          adjustments.value = response.body.adjustments;
          manualNextAdj.value = nextAdjustmentDimbookNo.value;
          rows.value = response.body.rows;

          if (response.body.work_order.draft) {
            rows.value = JSON.parse(response.body.work_order.draft);
          }

          // if (rows.value.length === 0) {
          //   rows.value.push({
          //     adjustment: DIMBOOK_ADJUSTMENT.INSERT,
          //     dim_book: response.body.dimbooks[0].id,
          //     dim_book_adjustment: null,
          //     order_no: 100,
          //     line_no: 1,
          //     id: uuid(),
          //   })
          // }
        }
      }
    };

    // Search
    const searchTextField = ref();
    const searchString = ref(null);
    const internalSearchString = ref(null);
    const onSearchInputChange = _.debounce(function (s) {
      if (s && s.toUpperCase) {
        internalSearchString.value = s;
      } else {
        internalSearchString.value = null;
      }
    }, 1000);
    const searchResults = computed(() => {
      if (internalSearchString.value) {
        const upperCased = internalSearchString.value.toUpperCase();
        return _.filter(processedRows.value, (r) => {
          // Line No
          const line_no =
            props.publicMode || (workOrder.value && workOrder.value.is_estimate)
              ? r.row_index
              : r.line_no;
          if (line_no && line_no.toString() === upperCased) {
            return true;
          }

          // Order No
          if (r.order_no.toString() === upperCased) {
            return true;
          }

          // Item No
          // const itemNo = getRawRowItemNo(r);
          const itemNo = r.item_no;
          if (itemNo && itemNo.indexOf(upperCased) !== -1) {
            return true;
          }

          // Description (should also include item no)
          // const description = getRawRowItemDescription(r);
          const description = r.descriptions;
          if (
            description &&
            description.toUpperCase().indexOf(upperCased) !== -1
          ) {
            return true;
          }

          // Location
          if (
            r.location &&
            r.location.toUpperCase().indexOf(upperCased) !== -1
          ) {
            return true;
          }

          // Location
          if (r.remark && r.remark.toUpperCase().indexOf(upperCased) !== -1) {
            return true;
          }

          return false;
        });
      }

      return [];
    });
    const selectedSearchResult = ref(null);
    const onSearchResultSelected = function (selected) {
      if (selected) {
        searchTextField.value.reset();

        const rowGroupIdx = _.findIndex(processedRows.value, {
          id: selected.id,
        });
        document.getElementsByClassName("dim-book-row-wrapper")[0].scrollTo({
          left: 0,
          top: rowGroupIdx * 65,
          behavior: "smooth",
        });
      }
    };
    const isSearchResultLoading = ref(false);
    const onSearch = function (e) {
      if (e.ctrlKey && e.key === "f") {
        e.preventDefault();
        searchTextField.value.focus();
      }
    };

    onMounted(() => {
      window.addEventListener("keypress", onSearch);
    });
    onUnmounted(() => {
      window.removeEventListener("keypress", onSearch);
    });

    const generateExcel = async function () {
      if (!(await check(true))) {
        return;
      }

      var wb = XLSX.utils.book_new();
      let ws = XLSX.utils.aoa_to_sheet([
        [
          "Works Order No.:",
          workOrder.value ? workOrder.value.work_order_no : "",
        ],
        [
          "Project Title:",
          props.publicMode
            ? ""
            : workOrder.value
            ? workOrder.value.name
            : props.sorName,
        ],
        [props.sorName],
        [
          "Date:",
          new Date(),
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          "Total Amount:",
          {
            f:
              props.publicMode ||
              (workOrder.value && workOrder.value.is_estimate)
                ? "=SUM(O5:O99999)"
                : "=SUM(Q5:Q99999)",
            z: '_([$HK$-zh-HK]* #,##0.00_);_([$HK$-zh-HK]* (#,##0.00);_([$HK$-zh-HK]* "-"??_);_(@_)',
          },
        ],
        [],
        [
          // 'Book No.',
          "Line No.",
          "Item No.",
          "Item Description",
          "NSR",
          "Rate",
          "Unit",
          "Times",
          ...(props.publicMode ||
          (workOrder.value && workOrder.value.is_estimate)
            ? []
            : ["Sub Ind"]),
          "1st Meas",
          "2nd Meas",
          "3rd Meas",
          ...(props.publicMode ||
          (workOrder.value && workOrder.value.is_estimate)
            ? []
            : ["Location"]),
          "Remark",
          // 'Qty',
          "Row Qty",
          "Dim Book Amount",
          ...(props.publicMode ||
          (workOrder.value && workOrder.value.is_estimate)
            ? ["Contract %"]
            : ["Trade %"]),
          "Contract Amount",
          ...(props.publicMode ||
          (workOrder.value && workOrder.value.is_estimate)
            ? []
            : ["G"]),
          // 'Adjusted Unit Rate',
        ],
      ]);

      // let rowIdx = 1;
      let rowIdx = 7;
      let rowsInGroup = [];
      let processGroup = function () {
        let noOfUnit = 0;

        _.forEach(rowsInGroup, (row) => {
          let rowQty = "a";
          for (let i = 0; i < row.dimension_count; i++) {
            let field = [
              { key: "first_measurement", label: "1st Dimension" },
              { key: "second_measurement", label: "2nd Dimension" },
              { key: "third_measurement", label: "3rd Dimension" },
            ][i];

            if (field) {
              let key = field.key;
              let dimension = row[key];
              if (dimension) {
                let parsedDimension = parseFloat(dimension);
                if (!isNaN(parsedDimension)) {
                  if (rowQty === "a") {
                    rowQty = parsedDimension;
                  } else {
                    rowQty *= parsedDimension;
                  }
                }
              }
            }
          }

          let percentage = 0;
          if (row.percentage) {
            let parsed = parseFloat(row.percentage);
            if (!isNaN(parsed) && parsed > -100) {
              percentage = parsed;
            }
          }

          if (rowQty !== "a") {
            // No. of Unit
            if (row.times) rowQty *= parseFloat(row.times);
            if (row.subtract) rowQty *= -1;
            rowQty *= (100 + percentage) / 100;
            noOfUnit += rowQty;
          }
        });

        _.forEach(rowsInGroup, (row) => {
          XLSX.utils.sheet_add_aoa(
            ws,
            [
              [
                // props.dimBook ? props.dimBook.work_order.name : '', // Book No.
                props.publicMode ? row.row_index : row.line_no, // Line No.
                row.item_no, // Item No.
                row.descriptions,
                row.nsr ? "Y" : "",
                { v: getRowValue(row), t: "n", z: "#,##0.00" },
                getRowUnit(row),
                row.times || 1,
                ...(props.publicMode ||
                (workOrder.value && workOrder.value.is_estimate)
                  ? []
                  : [row.subtract ? "N" : null]),
                { v: row.first_measurement, t: "n", z: "#,##0.00" },
                { v: row.second_measurement, t: "n", z: "#,##0.00" },
                { v: row.third_measurement, t: "n", z: "#,##0.00" },
                ...(props.publicMode ||
                (workOrder.value && workOrder.value.is_estimate)
                  ? []
                  : [row.location]),
                row.remark,
                {
                  f:
                    props.publicMode ||
                    (workOrder.value && workOrder.value.is_estimate)
                      ? `=ROUND(+IF(ISBLANK(G${rowIdx}), 1, G${rowIdx})*IF(ISBLANK(H${rowIdx}), 0, H${rowIdx})*IF(ISBLANK(I${rowIdx}), 1, I${rowIdx})*IF(J${rowIdx}="", 1, J${rowIdx}),2)`
                      : `=ROUND(+IF(ISBLANK(H${rowIdx}), 1, -1)*IF(ISBLANK(G${rowIdx}), 1, G${rowIdx})*IF(ISBLANK(I${rowIdx}), 0, I${rowIdx})*IF(J${rowIdx}="", 1, J${rowIdx})*IF(K${rowIdx}="", 1, K${rowIdx}), 2)`,
                  t: "n",
                  z: "#,##0.00",
                }, // Row Qty
                {
                  f:
                    props.publicMode ||
                    (workOrder.value && workOrder.value.is_estimate)
                      ? `=ROUND(L${rowIdx} * E${rowIdx}, 2)`
                      : `=ROUND(N${rowIdx} * E${rowIdx}, 2)`,
                  t: "n",
                  z: "#,##0.00",
                }, // Dimbook Amount: Qty * Rate
                { v: row.percentage || null, t: "n", z: "#,##0.00" },
                {
                  f:
                    props.publicMode ||
                    (workOrder.value && workOrder.value.is_estimate)
                      ? `=+ROUND(L${rowIdx}*E${rowIdx}*IF(ISBLANK(N${rowIdx}), 1, 1+N${rowIdx}/100), 2)`
                      : `=+ROUND(O${rowIdx}*IF(ISBLANK(P${rowIdx}), 1, 1+P${rowIdx}/100), 2)`,
                  t: "n",
                  z: "#,##0.00",
                }, // Contract Amount: Dimbook Amount * (1 + Trade%)
                ...(props.publicMode ||
                (workOrder.value && workOrder.value.is_estimate)
                  ? []
                  : [row.group ? "G" : null]),
              ],
            ],
            { origin: -1 },
          );
          rowIdx += 1;
        });
        rowsInGroup = [];
      };
      _.forEach(processedRows.value, (row) => {
        if (editedRowIds.value.indexOf(row.id) === -1) {
          rowsInGroup.push(row);

          if (props.publicMode || row.group) {
            processGroup();
          }
        }
      });
      processGroup();

      ws["!cols"] = [];
      ws["!cols"][2] = { wch: 40 };
      if (props.publicMode) {
        ws["!cols"][14] = { wch: 20 };
        ws["!cols"][16] = { wch: 20 };
      } else {
        ws["!cols"][16] = { wch: 20 };
        ws["!cols"][18] = { wch: 20 };
      }

      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, "Works Order Estimate.xlsx");
    };

    const generateXml = async function () {
      if (!(await check(true))) {
        return;
      }

      let xml =
        '<WorksOrderUpload xmlns="http://www.xml.gov.hk/schemas/2005/action" xmlns:xsi="http://www.w3.org/2001/XMLSchema">';
      xml += `<WorksOrderInformation><WorksOrderNo>${workOrder.value.work_order_no}</WorksOrderNo></WorksOrderInformation>`;

      let newRowsByDimBook = _.groupBy(
        _.filter(processedRows.value, (r) => !r.adjustment_dimbook_no),
        "dim_book",
      );
      // let nextDimBookNo = nextAdjustmentDimbookNo.value;

      let nextDimBookNo = manualNextAdj.value;

      xml += `<AdjustmentDimbookHeaders>`;
      _.forEach(_.sortBy(dimbooks.value, "dim_book_no"), (dimBook) => {
        // ER367
        let newNextLineForXML = 0;
        const originalDimBookRows = _.filter(
          processedRows.value,
          (r) => r.adjustment === "O" && r.dim_book === dimBook.id,
        );

        if (originalDimBookRows.length === 0) {
          newNextLineForXML = 1;
        } else {
          const maxLineNo = _.maxBy(originalDimBookRows, "line_no").line_no;
          newNextLineForXML = maxLineNo + 1;
        }

        // sort the new rows by dimbook by line_no, other not change
        const sortedNewRowsByDimbook = _.chain(newRowsByDimBook[dimBook.id])
          .groupBy((row) => row.adjustment === "I")
          .mapValues((rows, isInsert) => {
            if (isInsert === "true") {
              return _.sortBy(rows, "line_no").map((row, index) => {
                if (index !== 0) {
                  newNextLineForXML = newNextLineForXML + 1;
                }

                return {
                  ...row,
                  line_no: newNextLineForXML, // Adjust line numbers to be sequential
                };
              });
            }
            return rows;
          })
          .values()
          .flatten()
          .value();

        if (newRowsByDimBook[dimBook.id]) {
          xml += `<AdjustmentDimbookHeader><AdjustmentDimbookNo>${nextDimBookNo}</AdjustmentDimbookNo><DimbookNo>${dimBook.dimbook_no}</DimbookNo><AdjustmentDimbookItems>`;

          _.forEach(sortedNewRowsByDimbook, (row, idx, arr) => {
            let percentage = row.percentage;
            if (workOrder.value && workOrder.value.is_estimate && row.item) {
              let p =
                contractPercentageMap.value[
                  row.item.item_group.sub_sub_section.sub_section.section.order_no.toString()
                ];
              if (p) {
                percentage = p;
              }
            }

            xml += "<AdjustmentDimbookItem>";

            xml += `<SortId>${row.order_no
              .toString()
              .padStart(7, "0")}${nextDimBookNo}</SortId>`;
            xml += `<LineNo>${row.line_no}</LineNo>`;
            if (getRawRowItemNo(row))
              xml += `<ItemNo>${getRawRowItemNo(row)}</ItemNo>`;
            if (getRowUnitId(row))
              xml += `<ScheduleOfRateUnitId>${getRowUnitId(
                row,
              )}</ScheduleOfRateUnitId>`;
            if (row.nsr)
              xml += `<NonScheduleRateIndicator>Y</NonScheduleRateIndicator>`;
            if (percentage) xml += `<Percent>${percentage}</Percent>`;
            if (row.subtract) xml += `<SubtractIndicator>N</SubtractIndicator>`;
            if (row.times) xml += `<Timesing>${row.times}</Timesing>`;
            if (row.first_measurement)
              xml += `<FirstMeasure>${row.first_measurement}</FirstMeasure>`;
            if (row.second_measurement)
              xml += `<SecondMeasure>${row.second_measurement}</SecondMeasure>`;
            if (row.third_measurement)
              xml += `<ThirdMeasure>${row.third_measurement}</ThirdMeasure>`;
            if (
              row.group ||
              (workOrder.value &&
                workOrder.value.is_estimate &&
                idx + 1 === arr.length)
            )
              xml += `<GroupIndicator>G</GroupIndicator>`;
            if (row.location)
              xml += `<Location>${_.escape(row.location)}</Location>`;
            if (row.remark) xml += `<Remarks>${_.escape(row.remark)}</Remarks>`;
            xml += `<Order>${row.order_no}</Order>`;
            xml += `<AdjustmentIndicator>${row.adjustment}</AdjustmentIndicator>`;

            xml += "</AdjustmentDimbookItem>";
          });
          xml += "</AdjustmentDimbookItems></AdjustmentDimbookHeader>";

          // let num = parseInt(nextDimBookNo.substring(1));
          // nextDimBookNo = `A${(num + 1).toString().padStart(3, '0')}`;
          let number = parseInt(nextDimBookNo.slice(1)) + 1;
          nextDimBookNo = "A" + number.toString().padStart(3, "0");
        }
      });
      xml += `</AdjustmentDimbookHeaders>`;

      // _.forEach(_.filter(processedRows.value, (r) => !r.adjustment_dimbook_no), (row, idx, arr) => {
      //
      // });

      xml += "<QueryDetails/>";
      xml += "<SupportingDocuments/>";
      xml += "</WorksOrderUpload>";

      let blob = new Blob([xml], { type: "application/xml" });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${manualNextAdj.value}.xml`;
      link.click();
    };

    const selectItem = async function (evt) {
      const result = await root.$dialog.showAndWait(SearchSorDialog, {
        workOrder: workOrder.value,
        sorId: props.sorId || workOrder.value.contract.sor,
        sorName: props.sorName,
        width: "90vw",
        persistent: true,
      });
      setTimeout(() => {
        evt.target.blur();
        evt.preventDefault();
      }, 5);
      if (result === undefined) {
        throw "";
      } else {
        return {
          item: result,
        };
      }
    };
    const selectNsrItem = async function (evt) {
      const result = await root.$dialog.showAndWait(SearchNsrDialog, {
        workOrder: workOrder.value,
        showClose: false,
        width: "90vw",
      });
      setTimeout(() => {
        evt.target.blur();
        evt.preventDefault();
      }, 5);
      if (result === undefined) {
        throw "";
      } else {
        return {
          nsr_item_id: result.id,
          nsr_item_no: result.item_no,
          nsr_action_description: result.action_description,
          nsr_value: result.value,
          nsr_unit: result.unit,
          nsr_unit_id: result.unit_id,
        };
      }
    };

    watch(
      () => props.workOrderId,
      (newValue) => {
        if (newValue) {
          load();
        } else {
          if (rows.value.length === 0) {
            rows.value.push({
              adjustment: DIMBOOK_ADJUSTMENT.INSERT,
              order_no: 100,
              line_no: 1,
              id: uuid(),
            });
          }
        }
      },
      { immediate: true },
    );

    const checkSum = ref(null);
    const checkIssues = ref([]);
    const isIssueMenuVisible = ref(false);
    const rowIdsWithIssues = computed(() => {
      return _.uniqBy(checkIssues.value, "row.id").map((i) => i.row.id);
    });
    const clickedRowId = ref(null);
    const onIssueClick = function (row) {
      clickedRowId.value = row.id;
      const rowGroupIdx = _.findIndex(processedRows.value, { id: row.id });
      document.getElementsByClassName("dim-book-row-wrapper")[0].scrollTo({
        left: 0,
        top: rowGroupIdx * 65,
        behavior: "smooth",
      });
    };
    const check = async function (suppressSuccessMsg) {
      clickedRowId.value = null;

      let sum = 0;

      let issues = [];
      let rowsInGroup = [];

      let rowAmounts = {};

      const processGroup = async function () {
        let groupDimensions = 99;
        let itemInGroup = false;
        let itemInLastRow = false;
        let fullDimensionRowInGroup = false;
        let dimensionsInLastRow = false;
        let unitPrices = [];
        let noOfUnit = 0;
        let nsrItemRows = {};

        // Find first row with item / NSR item
        let rowWithUnit = _.find(rowsInGroup, (r) => {
          return r.nsr ? !!r.nsr_unit_id : !!r.item;
        });
        if (rowWithUnit) {
          groupDimensions = getRawRowDimensionCount(rowWithUnit);
        }

        _.forEach(rowsInGroup, (row) => {
          // Grouping NSR Item No.s' for validation
          if (row.nsr && row.nsr_item_no) {
            nsrItemRows[row.nsr_item_no] = row;
          }

          let itemInRow = false;
          // Item + Unit Price
          if (!row.nsr && row.item) {
            unitPrices.push(parseFloat(row.item.value));
            itemInRow = true;
            // itemInGroup = true;
          }
          if (row.nsr && row.nsr_value) {
            unitPrices.push(parseFloat(row.nsr_value));
            itemInRow = true;
          }

          // %
          let percentage = 0;
          if (row.percentage) {
            if (row.percentage.toString) {
              row.percentage = row.percentage.toString();
            }

            let r = new RegExp(
              props.publicMode ||
              (workOrder.value && workOrder.value.is_estimate)
                ? "^\\-?[0-9]*\\.?[0-9]{0,2}$"
                : "^[\\-0-9\\.]{1,3}$",
              "g",
            );
            if (r.test(row.percentage)) {
              let parsed = parseFloat(row.percentage);
              if (isNaN(parsed) || parsed <= -100) {
                issues.push({
                  row,
                  issue: props.publicMode
                    ? "Invalid Contract %"
                    : "Invalid Trade %",
                });
              } else {
                percentage = parsed;
              }
            } else {
              issues.push({
                row,
                issue: props.publicMode
                  ? "Invalid Contract %"
                  : "Invalid Trade %",
              });
            }
          }

          // Times
          if (row.times) {
            if (row.times.toString) {
              row.times = row.times.toString();
            }

            let r = new RegExp(
              props.publicMode ||
              (workOrder.value && workOrder.value.is_estimate)
                ? "^\\-?[0-9]*\\.?[0-9]{0,2}$"
                : "^[\\-0-9\\.]{1,3}$",
              "g",
            );
            if (r.test(row.times)) {
              let parsed = parseFloat(row.times);
              if (
                isNaN(parsed) ||
                (parsed <= 0 &&
                  !!workOrder.value &&
                  !workOrder.value.is_estimate)
              ) {
                issues.push({ row, issue: "Invalid Times" });
              }
            } else {
              issues.push({ row, issue: "Invalid Times" });
            }
          }

          // Dimensions
          let dimensionInRow = false;
          let rowDimension = getRawRowDimensionCount(row);
          if (
            groupDimensions !== 99 &&
            rowDimension !== 99 &&
            groupDimensions !== rowDimension
          ) {
            issues.push({ row, issue: "Mismatched Unit" });
            // groupDimensionMismatch = true;
          }
          let rowHasAllDimensions = true;
          let missingDimensionIssues = [];
          for (let i = 0; i < row.dimension_count; i++) {
            let field = [
              { key: "first_measurement", label: "1st Dimension" },
              { key: "second_measurement", label: "2nd Dimension" },
              { key: "third_measurement", label: "3rd Dimension" },
            ][i];

            if (field) {
              let key = field.key;
              let dimension = row[key];
              if (dimension && dimension.toString)
                dimension = dimension.toString();
              if (dimension) {
                let components = dimension.split(".");
                if (components.length > 1 && components[1].length > 2) {
                  issues.push({
                    row,
                    issue: `${field.label} have a maximum of 2 decimal places only`,
                  });
                  dimensionInRow = true;
                }

                let parsedDimension = parseFloat(dimension);
                if (isNaN(parsedDimension)) {
                  issues.push({ row, issue: `Invalid ${field.label}` });
                  dimensionInRow = true;
                } else {
                  if (parsedDimension >= 100000 || parsedDimension <= 0) {
                    issues.push({
                      row,
                      issue: `${field.label} out of range (0.01 - 99999.99)`,
                    });
                    dimensionInRow = true;
                  } else {
                    dimensionInRow = true;
                  }
                }
              } else if (!row.nsr) {
                rowHasAllDimensions = false;
                missingDimensionIssues.push({
                  row,
                  issue: `${field.label} Missing`,
                });
                // dimensionInRow = true;
              }
            }
          }

          if (!itemInRow && !dimensionInRow) {
            issues.push({ row, issue: "Empty Row" });
          }

          if (!itemInGroup && !itemInRow) {
            issues.push({ row, issue: "Missing Item" });
          }
          if (itemInGroup && itemInRow && !itemInLastRow) {
            issues.push({ row, issue: "Empty Item row above this row" });
          }

          if (!fullDimensionRowInGroup && !dimensionInRow) {
            issues.push({ row, issue: "No valid dimensions in Row" });
          }
          if (
            fullDimensionRowInGroup &&
            dimensionInRow &&
            !dimensionsInLastRow
          ) {
            issues.push({ row, issue: "Empty Dimension row above this row" });
          }
          if (dimensionInRow && missingDimensionIssues.length > 0) {
            issues.push(...missingDimensionIssues);
          }

          if (dimensionInRow) {
            // No. of Unit
            let product = parseFloat(row.first_measurement) || 0;
            if (row.second_measurement)
              product *= parseFloat(row.second_measurement);
            if (row.third_measurement)
              product *= parseFloat(row.third_measurement);
            if (row.times) product *= parseFloat(row.times);
            if (row.subtract) product *= -1;
            product = parseFloat(product.toFixed(2));
            product *= (100 + percentage) / 100;
            noOfUnit += product;

            if (getRowValue(row)) {
              let amount = getRowValue(row) * product;
              if (Math.abs(amount) > 9999999999.99) {
                issues.push({
                  row,
                  issue: "Calculated Amount exceeds the system limit",
                });
              }
              rowAmounts[row.id] = amount.toFixed(2);
              sum += amount;
            }
          }

          // Location
          if (row.location && row.location.length > 50) {
            issues.push({ row, issue: "Location length > 50 characters" });
          }

          if (!props.publicMode) {
            if (!row.location) {
              issues.push({ row, issue: "Location cannot be empty" });
            }
          }

          // Remark
          if (row.nsr && !row.remark) {
            issues.push({ row, issue: "Remark is mandatory for NSR items" });
          }

          if (row.remark && row.remark.length > 60) {
            issues.push({ row, issue: "Remark length > 60 characters" });
          }

          itemInGroup = itemInGroup || itemInRow;
          itemInLastRow = itemInRow;
          fullDimensionRowInGroup =
            fullDimensionRowInGroup || rowHasAllDimensions;
          dimensionsInLastRow = rowHasAllDimensions;
        });

        if (_.keys(nsrItemRows).length > 0) {
          const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
            url: "admin/sor/items/",
            params: {
              sor_id: props.publicMode
                ? props.sorId
                : workOrder.value.contract.finalised_sor,
              filters: {
                item_no: _.keys(nsrItemRows),
              },
              page_size: -1,
            },
          });

          if (response.body.success) {
            response.body.items.forEach((i) => {
              issues.push({
                row: nsrItemRows[i.item_no],
                issue: `NSR Item No. ${i.item_no} already exists in SoR`,
              });
            });
          }
        }

        if (!props.publicMode && !workOrder.value.is_estimate) {
          // if (groupDimensionMismatch) {
          //   issues.push({row: rowsInGroup[0], issue: 'Mixed Units in Group'});
          // }

          if (!itemInGroup) {
            issues.push({ row: rowsInGroup[0], issue: "No item in Group" });
          }

          if (noOfUnit === 0) {
            issues.push({
              row: rowsInGroup[0],
              issue: "No dimensions in Group",
            });
          }
        }

        let groupTotal =
          _.reduce(unitPrices, (s, unitPrice) => {
            return s + unitPrice;
          }) * noOfUnit;

        // if (groupTotal) {
        //   sum += groupTotal;
        // }

        rowsInGroup = [];
      };

      for (let i = 0; i < processedRows.value.length; i++) {
        let row = processedRows.value[i];
        if (
          row.idx === row.group_length - 1 &&
          editedRowIds.value.indexOf(row.id) === -1 &&
          row.adjustment !== DIMBOOK_ADJUSTMENT.DELETE
          // (row.adjustment_dimbook_no ||
          //   row.adjustment !== DIMBOOK_ADJUSTMENT.DELETE)
        ) {
          rowsInGroup.push(row);

          if (
            props.publicMode ||
            (workOrder.value && workOrder.value.is_estimate) ||
            row.group
          ) {
            await processGroup();
          }
        }
      }

      if (rowsInGroup.length > 0) {
        await processGroup();
      }

      checkIssues.value = issues;

      checkSum.value = sum.toFixed(2);

      // Update Row Amounts
      rows.value = rows.value.map((r) => {
        return {
          ...r,
          ...(_.has(rowAmounts, r.id)
            ? {
                row_amount: rowAmounts[r.id],
              }
            : {}),
        };
      });

      if (checkIssues.value.length === 0) {
        console.log("NO PROBLEM!!");
        if (!suppressSuccessMsg) {
          alert("Checked with no issue");
        }
      }

      return checkIssues.value.length === 0;
    };

    const saveDraft = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/contract/work_order/save_draft/",
        params: {
          work_order_id: props.workOrderId,
          draft: JSON.stringify(rows.value),
        },
      });

      if (response.body.success) {
        root.$store.dispatch(
          ACTION_TYPES.SHOW_SNACKBAR,
          "The Dimbook is saved",
        );
      }
    };

    return {
      workOrder,

      adjustments,
      adjustmentMap,
      processedRows,
      manualNextAdj,

      onEditRowOrderNo,
      getRawRowItemNo,
      onRowItemNoClick,
      onRowItemNoInput,
      shouldShowItemNoAppendIcon,
      onRowItemNoAppendClick,

      getRawRowItemDescription,
      onRowItemDescriptionInput,
      showRowItemDetail,

      getRowValue,
      getRowUnit,
      getRowAmount,

      onNsrValueInput,
      onNsrUnitInput,

      onPublicContractPercentageInput,

      getValue,
      onRowEdit,
      onValueInput,
      onRowInsert,
      onRowNsr,
      onRowDelete,

      searchTextField,
      searchString,
      searchResults,
      selectedSearchResult,
      onSearchResultSelected,
      isSearchResultLoading,
      onSearchInputChange,
      onSearch,

      generateExcel,
      generateXml,
      rows,
      editedRowIds,
      newRows,

      checkSum,
      checkIssues,
      isIssueMenuVisible,
      rowIdsWithIssues,
      clickedRowId,
      onIssueClick,
      check,
      saveDraft,

      DIMBOOK_ADJUSTMENT,
    };
  },
};
</script>

<style lang="less">
.dim-book-input {
  //background-color: #FFFFFF;
  display: flex;
  flex-direction: column;

  .dim-book-input-header-row {
    flex: 0 0 auto;
    padding: 16px;
    display: flex;
  }

  .dim-book-input-btn-row {
    background-color: #ffffff;
    padding: 16px;
    display: flex;
  }

  .dim-book-input-search-text-field {
    flex: 0 0 200px !important;
  }

  .dim-book-input-table {
    background-color: #ffffff;
    flex: 1 1 0;

    display: flex;
    overflow: auto;

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    input[type="number"] {
      -moz-appearance: textfield;
      appearance: textfield;
    }

    .dim-book-input-table-wrapper {
      min-width: 2300px;
      flex: 1 1 0;
      display: flex;
      flex-direction: column;

      &.public-mode {
        min-width: 1700px !important;
      }

      .dim-book-input-header-row {
        background-color: #faf8f8;
        padding: 0 16px;
        display: flex;
        gap: 4px;

        .dim-book-input-header {
          display: flex;
          justify-content: center;
          align-items: flex-end;
        }
      }

      .dim-book-row-wrapper {
        flex: 1 1 0;
        overflow: auto;
        flex-direction: column;

        .vue-recycle-scroller__item-wrapper {
          overflow: visible;
        }

        .dim-book-row {
          width: 100%;

          &.edited {
            opacity: 0.5;
          }

          &.has-issue {
            border: solid red 2px;
          }

          &.issue-clicked {
            background: rgba(255, 0, 0, 0.1);
          }

          .dim-book-line {
            padding: 8px 16px 0;
            //min-height: 100px;
            display: flex;
            align-items: stretch;
            gap: 4px;

            &.nsr-item {
              background: rgba(255, 255, 0, 0.3);
            }

            .dim-book-line-col {
              display: flex;
              align-items: center;
              word-break: break-all;

              .deleted {
                text-decoration: line-through;
              }
            }
          }

          .dim-book-row-bottom {
            height: 0;
            border-bottom: solid 3px #d2cbcb;
            position: relative;
            padding-top: 16px;

            .dim-book-row-bottom-add-btn {
              position: absolute;
              top: 0;
              height: 24px;
              left: 12px;
              background-color: #c11a1e;
              border-radius: 5px;
              display: flex;
              visibility: hidden;
            }

            //&:not(.disabled) {
            //  cursor: pointer;
            //
            //  &:hover {
            //    border-bottom: solid 3px #C11A1E;
            //
            //    .dim-book-row-bottom-add-btn {
            //      visibility: visible;
            //    }
            //  }
            //}
          }
        }

        .hover {
          .dim-book-row-bottom {
            cursor: pointer;
            border-bottom: solid 3px #c11a1e;

            .dim-book-row-bottom-add-btn {
              visibility: visible;
            }
          }
        }
      }
    }
  }

  .dim-book-adjustment,
  .dim-book-line-status,
  .dim-book-line-line-no,
  .dim-book-line-created-by {
    justify-content: center;
  }

  .dim-book-adjustment {
    &.new-adjustment {
      color: var(--v-primary-base);
      font-weight: bold;
    }
  }

  .dim-book-line-status {
    flex: 0 0 75px;
  }

  .dim-book-line-sub-ind,
  .dim-book-line-group {
    flex: 0 0 35px;
  }

  .dim-book-adjustment,
  .dim-book-line-line-no {
    flex: 0 0 75px;
  }

  .dim-book-line-measurement-header {
    flex: 0 0 308px;
    flex-wrap: wrap;
  }

  .dim-book-line-measurements {
    flex: 0 0 100px;

    &.disabled {
      background: rgb(240, 240, 240);
    }
  }

  .dim-book-line-order-no {
    flex: 0 0 90px;
  }

  .dim-book-line-actions,
  .dim-book-line-contract-percentage {
    flex: 0 0 75px;
  }

  .dim-book-line-created-by {
    flex: 0 0 150px;
  }

  .dim-book-line-item-no {
    flex: 0 0 80px;
  }

  .dim-book-line-percentage {
    flex: 0 0 80px;
  }

  .dim-book-line-item-unit,
  .dim-book-line-times {
    flex: 0 0 65px;
  }

  .dim-book-line-amount {
    flex: 0 0 130px;
  }

  .dim-book-line-nsr-value {
    flex: 0 0 100px;
  }

  .dim-book-line-location {
    flex: 0 0 200px;
  }

  .dim-book-line-item-description,
  .dim-book-line-remark {
    flex: 0 0 300px;
  }

  .dim-book-line-item-description,
  .dim-book-line-item-unit {
    input {
      cursor: url("../../assets/magnify-plus-cursor.png") 0 0, zoom-in !important;
    }
  }

  .nsr-item {
    .dim-book-line-item-description,
    .dim-book-line-item-unit {
      input {
        cursor: text !important;
      }
    }
  }

  .dim-book-line-fake-input {
    border-radius: 5px;
    border: solid 1px #dddbdb;
    padding: 4px;
    height: 92px;
    overflow: auto;

    &.disabled {
      border: solid 1px #dddbdb !important;
      cursor: not-allowed;
      opacity: 0.1;
    }

    &:hover {
      border-color: var(--v-primary-base);
      border-width: 1px;
    }
  }
}
</style>
